var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstallerSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8573 15.5644C14.3781 15.5644 16.4216 13.5209 16.4216 11.0001C16.4216 8.47931 14.3781 6.43579 11.8573 6.43579C9.33648 6.43579 7.29297 8.47931 7.29297 11.0001C7.29297 13.5209 9.33648 15.5644 11.8573 15.5644Z",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8594 1.87146V3.69719",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8594 18.303V20.1287",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3151 4.54614L17.0273 5.83393",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69404 16.1669L5.40625 17.4547",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9859 11.0001H19.1602",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5562 11.0001H2.73047",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3151 17.4547L17.0273 16.1669",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69404 5.83393L5.40625 4.54614",
    stroke: "#3C3C3C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstallerSolar);
export default __webpack_public_path__ + "static/media/icon_installer_solar.283c8966e8f114bbbca9d3c3c7d4aa4f.svg";
export { ForwardRef as ReactComponent };